// A ordem já é fornecida pelo endpoint de artigos da seção.
export default function ordenarArtigosDaSecao(secao) {
  return (secao.artigos || []).slice();
}
